<script lang="ts">
    import { navigate } from "svelte-navigator";
    import * as _ from "underscore";
    import { ApiClient } from "../../GlobalHelper/ApiClient";
    import { user } from "../../store/stores";

    // export let id: string;

    let userDetails = { ...$user.extendedUserData };

    const updateUser = async () => {
        await $user.updateToken().then(async () => {
            const updateUser = userDetails;
            await ApiClient.getInstance($user)
                .userClient.updateUserAuthorizationUserIdContextOrganisation({
                    userId: $user.extendedUserData.id,
                    userUpdateRequest: {
                        ...updateUser,
                        organisationId: "0",
                        active: updateUser.active || false,
                    },
                })
                .then((userData) =>
                    user.update((userStore) => {
                        userDetails = { ...userData };
                        return {
                            ...userStore,
                            extendedUserData: { ...userData },
                        };
                    })
                );
        });
    };

    $: changedUser = _.isEqual(userDetails, $user.extendedUserData);
</script>

<div class="container">
    <div class="block">
        {#if userDetails}
            <div class="box">
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">Username</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input
                                            class="input"
                                            type="email"
                                            bind:value={userDetails.username}
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">E-Mail</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input
                                            class="input "
                                            type="email"
                                            bind:value={userDetails.email}
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">Status</label>
                            </div>
                            <div class="field-body">
                                <div class="select">
                                    <select
                                        bind:value={userDetails.active}
                                        disabled
                                    >
                                        <option value={true}>aktiv</option>
                                        <option value={false}
                                            >deaktiviert</option
                                        >
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">Vorname</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input
                                            class="input "
                                            type="email"
                                            bind:value={userDetails.firstName}
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">Nachname</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input
                                            class="input "
                                            type="email"
                                            bind:value={userDetails.lastName}
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12">
                        <div class="box">
                            <p class="is-size-5">Rollen</p>
                            <!-- <div class="tags">
                                {#each userDetails.o as role}
                                    <span class="tag is-primary">{role}</span>
                                {/each}
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        {/if}
        <div class="columns is-multiline first-row">
            <div
                class="column is-one-third is-flex is-justify-content-flex-start"
            >
                <button class="button" on:click={() => navigate(-1)}>
                    zurück
                </button>
            </div>
            <div
                class="column is-one-third is-offset-one-third is-flex is-justify-content-flex-end"
            >
                <button
                    class="button is-primary is-light"
                    disabled={changedUser}
                    on:click={() => updateUser()}
                >
                    Änderungen speichern
                </button>
            </div>
        </div>
    </div>
</div>

<style>
    .container {
        padding-top: 1rem;
    }
    .box {
        height: 100%;
        overflow: auto;
    }
</style>
